import { useUserCreatorData } from 'root/src/client/v2/common/hooks/useUser';
import { DarePlatform } from 'root/src/shared/@types/platforms';
import { useBestAvailablePlatformToken } from 'root/src/client/logic/dropEvent/hooks/useBestPlatform';
export function useDareAssignee({ dare, fallbackDrop }) {
    const { tokens } = useUserCreatorData();
    const bestPlatformToken = useBestAvailablePlatformToken(fallbackDrop);
    if (dare.platform === DarePlatform.Any && bestPlatformToken) {
        return { id: bestPlatformToken.platformId, platform: bestPlatformToken.platform };
    }
    const matchingPlatform = tokens === null || tokens === void 0 ? void 0 : tokens.find(token => token.platform === dare.platform);
    if (!matchingPlatform) {
        return null;
    }
    return { id: matchingPlatform.platformId, platform: matchingPlatform.platform };
}
